import { useMutation, useQueryClient } from "@tanstack/react-query";

import { errorHandler } from "#app/monitoring/errorHandler";
import { showErrorToast } from "#app/notifications";
import { bulkDeleteQuoteRequestLineSurfaceTreatments } from "#modules/quoteRequestLines/infra/bulkDeleteQuoteRequestLineSurfaceTreatments.api";
import { invalidateQuoteRequestLinesDebounced } from "#modules/quoteRequestLines/infra/invalidateQuoteRequestLinesDebounced";

export const useBulkDeleteQuoteRequestLineSurfaceTreatments = () => {
  const queryClient = useQueryClient();

  const { mutate, ...rest } = useMutation({
    mutationFn: (quoteRequestLineIds: string[]) =>
      bulkDeleteQuoteRequestLineSurfaceTreatments({
        payload: {
          quoteRequestLineIds,
        },
      }),
    onSuccess: (quoteRequestLinesId) => {
      quoteRequestLinesId.forEach((id) => {
        invalidateQuoteRequestLinesDebounced({
          queryClient,
          quoteRequestLineId: id,
        });
      });
    },
    onError: (err: Error) => {
      showErrorToast({ title: err.message });
      errorHandler(err);
    },
  });

  return { bulkDeleteQuoteRequestLineSurfaceTreatments: mutate, ...rest };
};
